import { TranRecordModel } from "./tran-record.model";

export class RefundProcModel {
    Trans: TranRecordModel[]
    intIndex: number
    intTotalIdx: number
    frmWorkScreen: string
    Tag: number
    intClinicNo: number
    intClinicType: number

    constructor(
        Trans: TranRecordModel[],
        intIndex: number,
        intTotalIdx: number,
        frmWorkScreen: string,
        Tag: number,
        intClinicNo: number,
        intClinicType: number
    ) {
        this.Trans = Trans
        this.intIndex = intIndex
        this.intTotalIdx = intTotalIdx
        this.frmWorkScreen = frmWorkScreen
        this.Tag = Tag
        this.intClinicNo = intClinicNo
        this.intClinicType = intClinicType
    }
}